/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Admin_2Inputs */

const da_privacy_admin_2 = /** @type {(inputs: Privacy_Admin_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til support kan en administrator også se klasselister på tværs af organisationer: klassens navn, hvem der har oprettet den, og elevernes numre og aliasser. Det er skrivebeskyttet, og besvarelser, point og karakterer kan ikke ses. Hver visning kræver en begrundelse og noteres i en log.`)
};

/** @type {(inputs: Privacy_Admin_2Inputs) => LocalizedString} */
const en_privacy_admin_2 = da_privacy_admin_2;

/**

* @param {Privacy_Admin_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_admin_2 = /** @type {((inputs?: Privacy_Admin_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Admin_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_admin_2(inputs)
	return /** @type {LocalizedString} */ ("Til support kan en administrator også se klasselister på tværs af organisationer: klassens navn, hvem der har oprettet den, og elevernes numre og aliasser. Det er skrivebeskyttet, og besvarelser, point og karakterer kan ikke ses. Hver visning kræver en begrundelse og noteres i en log.")
});